export const ADD_TO_EXECUTED_CODES = 'ADD_TO_EXECUTED_CODES';

export const addToExecutedCodes = (code) => ({
    type: ADD_TO_EXECUTED_CODES, code
});
